var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_4282)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54798 2.06069C3.96401 2.06069 1.86929 4.15541 1.86929 6.73939C1.86929 9.32336 3.96401 11.4181 6.54798 11.4181C9.13195 11.4181 11.2267 9.32336 11.2267 6.73939C11.2267 4.15541 9.13195 2.06069 6.54798 2.06069ZM0.429688 6.73939C0.429688 3.36035 3.16894 0.621094 6.54798 0.621094C9.92702 0.621094 12.6663 3.36035 12.6663 6.73939C12.6663 10.1184 9.92702 12.8577 6.54798 12.8577C3.16894 12.8577 0.429688 10.1184 0.429688 6.73939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56355 2.78125C6.96108 2.78125 7.28335 3.10351 7.28335 3.50105V6.29528L9.04485 7.17604C9.40041 7.35382 9.54454 7.78618 9.36675 8.14175C9.18897 8.49731 8.75661 8.64143 8.40104 8.46365L6.24165 7.38395C5.99779 7.26202 5.84375 7.01278 5.84375 6.74014V3.50105C5.84375 3.10351 6.16601 2.78125 6.56355 2.78125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_4282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9564,
    height: 12.9564,
    fill: "white",
    transform: "translate(0.0703125 0.261719)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d7e3b3bfa858b94a6a14e6b8748bfc84.svg";
export { ForwardRef as ReactComponent };